import type { OrganizationDto } from '~/api/organizations';

export const shouldFetchUserDashboard = (
  organizationDomain: string | null,
  organization: Pick<OrganizationDto, 'hasPublishedDashboard'> | null,
): boolean =>
  organizationDomain !== null && organization?.hasPublishedDashboard === true;
